import { createSlice } from "@reduxjs/toolkit";

const rootSlice = createSlice({
    name: "root",
    initialState: {
        openSlideBar: false,
        sideBarLink:null,
        activeTab: {
            dashboard: false,
            profile: false,
            calendar: false,
            payment: false,
            payout: false,
            players: false,
            notify: false,
            calenderSetup: false,
            adminReporting: false,
            planSetup: false,
            clubSetup: false,
            reservationHistory:false,
            accessManagement:false,
            inviteStaff:false,
            adsSponsorship: false
        },
        isPaymentDoneForReservation:{
            status:false,
            type:'init'
        },
        isUpdateTotalSchedule: true,
        disablePayBtn:false,
        initialTimer:0,
        isTimerActive:false,
        holdAskExtra:false,
        holdCreatedDate:null,
        holdExtraGrantedAt:null,
        holdPhaseSeconds:60,
        holdDisplay:"",
        paymentIntentId:null,
        isCheckoutConfigChange:false,
        warningMessage:{
            type:'',
            content:'',
            id:''
        }
    },
    reducers: {
        setOpenSlideBar: (state, action) => {
            state.openSlideBar = action.payload;
        },
        setIsCheckoutConfigChange:(state,action)=>{
            state.isCheckoutConfigChange=action.payload;
        },
        setIsUpdateTotalSchedule: (state, action) => {
            state.isUpdateTotalSchedule = action.payload;
        },
        setPaymentIntentId: (state, action) => {
            state.paymentIntentId = action.payload;
        },
        setInitialTimer: (state, action) => {
            state.initialTimer = action.payload;
        },
        setDisablePayBtn: (state, action) => {
            state.disablePayBtn = action.payload;
        },
        setIsTimerActive: (state, action) => {
            state.isTimerActive = action.payload;
        },
        setHoldAskExtra: (state, action) => {
            state.holdAskExtra = action.payload;
        },
        setHoldCreatedDate: (state, action) => {
            state.holdCreatedDate = action.payload;
        },
        setHoldExtraGrantedAt: (state, action) => {
            state.holdExtraGrantedAt = action.payload;
        },
        setHoldPhaseSeconds: (state, action) => {
            state.holdPhaseSeconds = action.payload;
        },
        setHoldDisplay: (state, action) => {
            state.holdDisplay = action.payload;
        },
        setSlideBarLink: (state, action) => {
            state.sideBarLink = action.payload;
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        setReservationPaymentStatus: (state, action) => {
            state.isPaymentDoneForReservation = action.payload;
        },
        setWarningMessage: (state, action) => {
            state.warningMessage = action.payload;
        }
    },
});

export const rootAction = rootSlice.actions;
export default rootSlice.reducer;